/** Desktop floor so sidebar resize can't squash VP cards into unusable sticks (esp. FFA 2×2). */
export const VP_PANEL_MIN_WIDTH_PX = {
  duel: 280,
  table: 260,
} as const;

/**
 * PlayerHalfFrame and the score card share one corner.
 *
 * The corner ornament (`frame-corner.svg`, drawn at 112 / 136 / 166px in
 * PlayerHalfFrame) chamfers on about 16 viewBox units of a 227-wide asset:
 *   112px → 8px, 136px → 10px, 166px → 12px.
 * That chamfer is the card radius. The frame radius is the card radius plus
 * the frame inset, so the legend art, the XP face, and the card stroke sit
 * on the ornament instead of drawing a rounder curve inside it.
 */
export const PLAYER_FRAME_RADIUS = { base: '12px', sm: '14px', md: '18px' } as const;
export const PLAYER_FRAME_INSET = { base: '4px', md: '6px' } as const;
export const PLAYER_PANEL_RADIUS = { base: '8px', sm: '10px', md: '12px' } as const;
